import { useState } from 'react';
import { Modal, Form, Button, Dropdown } from 'react-bootstrap';
import { Camera, X, FolderPlus } from 'lucide-react';

export default function UploadPhotosModal({ show, onHide, onUpload }) {
  const [uploadedImages, setUploadedImages] = useState([]);
  const [description, setDescription] = useState('');

  const handleFileUpload = (event) => {
    const files = event.target.files;
    if (files) {
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (typeof reader.result === 'string') {
            setUploadedImages((prev) => [
              ...prev,
              {
                id: Math.random().toString(36).substr(2, 9),
                url: reader.result,
              },
            ]);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const removeImage = (id) => {
    setUploadedImages((prev) => prev.filter((img) => img.id !== id));
  };

  const handleDone = () => {
    const photos = uploadedImages.map((img) => ({
      id: img.id,
      url: img.url,
      description: description,
      uploadedAt: new Date(),
    }));
    onUpload(photos);
    setUploadedImages([]);
    setDescription('');
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header className="border-bottom">
        <Modal.Title className="fw-bold d-flex align-items-center gap-2">
          Upload
          {uploadedImages.length > 0 && (
            <span className="text-muted fw-normal">
              {uploadedImages.length} out of {uploadedImages.length} uploaded
            </span>
          )}
        </Modal.Title>
        <Button variant="link" className="p-0 border-0 text-muted" onClick={onHide}>
          <X size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body className="p-4">
        <Form>
          <Form.Control
            as="textarea"
            placeholder="Write something about your photos, to be shown on your timeline"
            className="border-0 p-0 mb-4"
            style={{ resize: 'none' }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <div className="d-flex gap-3 flex-wrap mb-4">
            {/* Upload Box */}
            <div
              className="bg-light rounded-3 position-relative"
              style={{
                width: '180px',
                height: '180px',
                cursor: 'pointer',
              }}
            >
              <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                <Camera size={48} className="text-muted mb-2" />
                <h6 className="mb-1">Add Photos</h6>
                <p className="text-muted small mb-0">Or drag and drop</p>
              </div>
              <input
                type="file"
                className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
                accept="image/*"
                multiple
                onChange={handleFileUpload}
                style={{ cursor: 'pointer' }}
              />
            </div>

            {/* Uploaded Images */}
            {uploadedImages.map((image) => (
              <div
                key={image.id}
                className="position-relative"
                style={{
                  width: '180px',
                  height: '180px',
                }}
              >
                <img
                  src={image.url}
                  alt="Uploaded preview"
                  className="rounded-3 object-fit-cover w-100 h-100"
                  style={{ objectFit: 'cover', borderRadius: '8px' }}
                />
                <Button
                  variant="link"
                  className="position-absolute top-0 end-0 p-1 m-1 bg-white rounded-circle shadow-sm"
                  onClick={() => removeImage(image.id)}
                >
                  <X size={16} className="text-muted" />
                </Button>
              </div>
            ))}
          </div>

          <div className="d-flex align-items-center justify-content-between">
            <Button variant="link" className="text-primary p-0 d-flex align-items-center gap-2">
              <FolderPlus size={20} />
              Select Album
            </Button>

            <div className="d-flex align-items-center gap-3">
              <Dropdown>
                <Dropdown.Toggle variant="light" className="border">
                  Public
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item active>Public</Dropdown.Item>
                  <Dropdown.Item>Friends</Dropdown.Item>
                  <Dropdown.Item>Only me</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <Button
                variant="primary"
                disabled={uploadedImages.length === 0}
                onClick={handleDone}
              >
                Done
              </Button>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
